import { seededId } from '../ids';
import type { Mutation } from '../mutations';
import type { CategoryLike } from '../spending/categories';
import type { BuildCtx } from '../spending/types';
import { quitMutation } from './types';

/** Spending dropped Cigarettes from its defaults in v0.1.1; Quit Smoking creates it when turned on. */
export const CIGARETTES_CATEGORY = { key: 'cigarettes', name: 'Cigarettes', icon: 'cigarette' };

/**
 * Makes sure the Cigarettes category exists, on its seeded id seededId(u, 'category', 'cigarettes'):
 * - missing: an insert-if-absent seed (so it never overwrites a row this device hasn't pulled);
 * - soft-deleted (v0.1.1's cleanup, or the user): a plain insert with no values restores it and
 *   keeps whatever name it had, so a rename survives (conventions §14);
 * - live: nothing.
 */
export function buildEnsureCigarettesCategory(
  userId: string,
  existing: readonly CategoryLike[],
  ctx: BuildCtx,
): Mutation[] {
  const id = seededId(userId, 'category', CIGARETTES_CATEGORY.key);
  const row = existing.find((c) => c.id === id);
  if (row && row.deletedAt === null) return [];
  if (row) return [quitMutation(ctx, 'categories', 'insert', id, {})];
  const position =
    existing.filter((c) => c.deletedAt === null).reduce((max, c) => Math.max(max, c.position), 0) +
    1;
  return [
    quitMutation(
      ctx,
      'categories',
      'insert',
      id,
      {
        key: CIGARETTES_CATEGORY.key,
        name: CIGARETTES_CATEGORY.name,
        icon: CIGARETTES_CATEGORY.icon,
        hidden: false,
        position,
      },
      { ifAbsent: true },
    ),
  ];
}
